const creativeProjects = [
  {
    title: "Processing Projects",
    description: "A series of creative graphics projects built in Processing exploring 3D rendering, procedural generation, and animation.",
    image: "/assets/creative/processing.png",
    links: [
      { label: "GitHub", url: "https://github.com/he-larious/Processing-Projects" }
    ]
  },
  {
    title: "Image Processing",
    description: "A C++ image editor that implements blending modes (multiply, subtract, screen, overlay), channel extraction/combination, and transformations.",
    image: "/assets/creative/image-processing.jpg",
    links: [
      { label: "GitHub", url: "https://github.com/he-larious/Image-Processing" }
    ]
  }
];
export default creativeProjects;
